import React from 'react';
import { railsInputName } from 'members/helpers';
import Glyph from 'components/glyph';

require('app/javascripts/lodash-mixins.js');

class MemberGroupList extends React.Component {
  constructor(props) {
    super(props);

    this.groupIdInputName = this.groupIdInputName.bind(this);
  }

  groupIdInputName() {
    return `${railsInputName(this.props.memberId, 'group_ids')}[]`;
  };

  render() {
    if (!this.props.isVisible) { return (null); }

    if (this.props.isEditable) {
      return (
        <EditableMemberGroupList
          memberId={this.props.memberId}
          email={this.props.email || 'These member(s)'}
          canAccessAllGroups={this.props.canAccessAllGroups}
          groups={this.props.groups}
          groupIds={this.props.groupIds}
          onGroupCheckboxChange={this.props.onGroupCheckboxChange}
          groupIdInputName={this.groupIdInputName}
        />
      );
    } else {
      return (
        <ReadOnlyMemberGroupList
          memberId={this.props.memberId}
          canAccessAllGroups={this.props.canAccessAllGroups}
          groups={this.props.groups}
          groupIds={this.props.groupIds}
          glyph={this.props.glyph}
        />
      );
    }
  }
}



// *********************************************************************************
// Functional components
// *********************************************************************************



// responsible for rendering editable/selectable group list for a member
// *********************************************************************************
function EditableMemberGroupList(props) {
  let groups = _.chunkWithFiller(props.groups, 3, {}),
      rows = [];

  for (let row of groups) {
    let items = [];
    let key = row.map((g) => g.id).join('-');

    for (let group of row) {
      if (group.hasOwnProperty('id')) {
        let hasAccess = props.groupIds.includes(group.id);

        let item = <div key={group.id} className="grid-cell">
          <label>
            <input className="email-preference" type="checkbox" value={group.id}
              name={props.groupIdInputName()}
              defaultChecked={hasAccess}
              onChange={props.onGroupCheckboxChange}
            />
            {group.name}
          </label>
        </div>;

        items.push(item);
      } else {
        items.push(<div key={Math.random()} className='grid-cell' />);
      }
    }

    rows.push(<div key={key} className="grid flex sources">{items}</div>);
  }

  return (
    !props.canAccessAllGroups &&
      <div className="group-list">
        <h4>{props.email} will have access to...</h4>
        {rows}
      </div>
  );
};

// responsible for rendering the list of groups that a member
// can have access to, as well as showing what the member does have access to
// *********************************************************************************
function ReadOnlyMemberGroupList(props) {
  // no need to show the groups if full access
  if (props.canAccessAllGroups) { return(null); }

  // only show groups member has access to, not the full list
  let accessibleGroups = _.filter(props.groups, (group) => {
    return props.groupIds.includes(group.id);
  });

  let groups = _.chunkWithFiller(accessibleGroups, 3, {}),
      rows = [];

  for (let row of groups) {
    let items = [];
    let key = row.map((g) => g.id).join('-');

    for (let group of row) {
      if (group.hasOwnProperty('id')) {
        let item = <div key={group.id} className='grid-cell'>
          <p>
            <Glyph name={props.glyph(true)} /> {group.name}
          </p>
        </div>;

        items.push(item);
      } else {
        items.push(<div key={Math.random()} className='grid-cell' />);
      }
    }

    rows.push(<div key={key} className="grid flex sources">{items}</div>);
  }

  return (<div className="group-list">{rows}</div>);
};

export default MemberGroupList;
